import DefaultFactory from "/scripts/default/factory";
import ScrollHero from "/components/scroll/hero";
import ScrollPlugins from "/components/scroll/plugins";
import ScrollTriggerReady from "/components/scroll/trigger-ready";
import ScrollTriggerPin from "/components/scroll/trigger-pin";
import ScrollTriggerSize from "/components/scroll/trigger-size";
import ScrollSmoothBreeze from "/components/scroll/smooth-breeze";
import ScrollSmoothEffortless from "/components/scroll/smooth-effortless";
import ScrollSmoothButter from "/components/scroll/smooth-butter";
import ScrollSmoothEffects from "/components/scroll/smooth-effects";
import ScrollSeamless from "/components/scroll/seamless";
import ScrollObserver from "/components/scroll/scroll-observer";

/*
	Individual page factories follow the same principles as
	the global factory in /public/scripts/index.js but contain
	blocks that should only be checked for on a single page
*/
class ScrollFactory extends DefaultFactory {
	createBlock(blockName, block) {
		switch (blockName) {
			case "scroll-hero":
				return new ScrollHero(block);
			case "scroll-plugins":
				return new ScrollPlugins(block);
			case "scroll-trigger-ready":
				return new ScrollTriggerReady(block);
			case "scroll-trigger-pin":
				return new ScrollTriggerPin(block);
			case "scroll-trigger-size":
				return new ScrollTriggerSize(block);
			case "scroll-smooth-breeze":
				return new ScrollSmoothBreeze(block);
			case "scroll-smooth-effortless":
				return new ScrollSmoothEffortless(block);
			case "scroll-smooth-butter":
				return new ScrollSmoothButter(block);
			case "scroll-smooth-effects":
				return new ScrollSmoothEffects(block);
			case "scroll-seamless":
				return new ScrollSeamless(block);
			case "scroll-observer":
				return new ScrollObserver(block);
			default:
				return null;
		}
	}
}

new ScrollFactory();
